<template>
    <div>
        <v-dialog v-model="eligibledialog" max-width="800px">
            <template v-slot:activator="{ on }">
                <v-btn color="primary" dark class="mb-2" v-on="on" @click="resetSelections">+</v-btn>
            </template>
            <v-card>
                <v-card-title>
                    <span class="headline mb-4">{{ $t('attendanceincentivesetup.eligiblegroupitem') }}</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12" sm="12" md="12" class="mt-n8">
                                <v-autocomplete
                                    outlined
                                    :label="$t('attendanceincentivesetup.workgroup')"
                                    dense
                                    multiple
                                    small-chips
                                    deletable-chips
                                    :items="workgroupList"
                                    v-model="selections.workgroupids"
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="12" md="12" class="mt-n8">
                                <v-autocomplete
                                    outlined
                                    :label="$t('columns.company')"
                                    dense
                                    multiple
                                    small-chips
                                    deletable-chips
                                    :items="companyList"
                                    v-model="selections.compnyids"
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="12" md="12" class="mt-n8">
                                <v-autocomplete
                                    outlined
                                    :label="$t('columns.branch')"
                                    dense
                                    multiple
                                    small-chips
                                    deletable-chips
                                    :items="branchList"
                                    v-model="selections.branchids"
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="12" md="12" class="mt-n8">
                                <v-autocomplete
                                    outlined
                                    :label="$t('columns.department')"
                                    dense
                                    multiple
                                    small-chips
                                    deletable-chips
                                    :items="departmentList"
                                    v-model="selections.deptids"
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="12" md="12" class="mt-n8">
                                <v-autocomplete
                                    outlined
                                    :label="$t('columns.division')"
                                    dense
                                    multiple
                                    small-chips
                                    deletable-chips
                                    :items="divisionList"
                                    v-model="selections.divisionids"
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="12" md="12" class="mt-n8">
                                <v-autocomplete
                                    outlined
                                    :label="$t('columns.section')"
                                    dense
                                    multiple
                                    small-chips
                                    deletable-chips
                                    :items="sectionList"
                                    v-model="selections.sectionids"
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="12" md="12" class="mt-n8">
                                <v-autocomplete
                                    outlined
                                    :label="$t('columns.unit')"
                                    dense
                                    multiple
                                    small-chips
                                    deletable-chips
                                    :items="unitList"
                                    v-model="selections.unitids"
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="12" md="12" class="mt-n8">
                                <v-autocomplete
                                    outlined
                                    :label="$t('columns.employmenttype')"
                                    dense
                                    multiple
                                    small-chips
                                    deletable-chips
                                    :items="emptypeList"
                                    v-model="selections.emptypeids"
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="12" md="12" class="mt-n8">
                                <v-autocomplete
                                    outlined
                                    :label="$t('columns.grade')"
                                    dense
                                    multiple
                                    small-chips
                                    deletable-chips
                                    :items="gradeList"
                                    v-model="selections.gradeids"
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="12" md="12" class="mt-n8">
                                <v-autocomplete
                                    outlined
                                    :label="$t('columns.job')"
                                    dense
                                    multiple
                                    small-chips
                                    deletable-chips
                                    :items="jobList"
                                    v-model="selections.jobids"
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="12" md="12" class="mt-n8">
                                <v-autocomplete
                                    outlined
                                    :label="$t('columns.position')"
                                    dense
                                    multiple
                                    small-chips
                                    deletable-chips
                                    :items="positionList"
                                    v-model="selections.positionids"
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-text v-if="isErr" class="mt-n12">
                    <span style="font-weight: bold; color: red">{{ errMsg }}</span>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click="closeEligibleGroupInput">Cancel</v-btn>
                    <v-btn color="green darken-1" text @click="saveEligibleGroupInput">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-data-table
            :headers="this.parentObject.tabHeader"
            :items="detailItem"
            class="elavation-1"
            fixed-header
        >
            <template v-slot:item.action="{ item }">
                <v-icon small class="mr-2" @click="modifyItemHandler(item)">mdi-pen</v-icon>
                <v-icon small class="ml-3 mr-2" @click="deleteItemHandler(item)">mdi-delete</v-icon>
            </template>
        </v-data-table>
    </div>
</template>

<script>
export default {
    props: {
        parentObject: Object
    },

    data() {
        return {
            eligibledialog: false,
            detailItem: this.parentObject.detailItem,
            selections: this.emptySelections(),
            workgroupList: [], workgroupItems: [],
            companyList: [],   companyItems: [],
            branchList: [],    branchItems: [],
            departmentList: [], departmentItems: [],
            divisionList: [],  divisionItems: [],
            sectionList: [],   sectionItems: [],
            unitList: [],      unitItems: [],
            emptypeList: [],   emptypeItems: [],
            gradeList: [],     gradeItems: [],
            jobList: [],       jobItems: [],
            positionList: [],  positionItems: [],
            itemHolder: null,
            isExisting: false,
            isErr: false,
            errMsg: '',
        }
    },

    methods: {
        emptySelections() {
            return {
                id: null,
                workgroupids: [],  workgroupcodes: '',  workgroupdescs: '',
                compnyids: [],     companycodes: '',    companynames: '',
                branchids: [],     branchcodes: '',     branchnames: '',
                deptids: [],       deptcodes: '',       deptnames: '',
                divisionids: [],   divisioncodes: '',   divisionnames: '',
                sectionids: [],    sectioncodes: '',    sectionnames: '',
                unitids: [],       unitcodes: '',       unitnames: '',
                emptypeids: [],    emptypecodes: '',    emptypedescs: '',
                gradeids: [],      gradecodes: '',      gradedescs: '',
                jobids: [],        jobcodes: '',        jobtitles: '',
                positionids: [],   positioncodes: '',   positiondescs: '',
                action: 0,
                stamp: 0,
            };
        },

        toIdArray(value) {
            if (Array.isArray(value)) return [...value];
            if (value === null || value === undefined || value === '') return [];
            return String(value).split(',').map(Number);
        },

        loadWorkgroup() {
            const vm = this;
            this.$store.dispatch('get', { url: '/groupp_grouppb_workday/all' })
                .then(res => {
                    vm.workgroupItems = res.data.rec;
                    res.data.rec.forEach(r => vm.workgroupList.push({ text: r.valuedesc, value: r.valvalueid }));
                })
                .catch(err => { vm.errMsg = err; });
        },

        loadCompany() {
            const vm = this;
            this.$store.dispatch('get', { url: '/company/all' })
                .then(res => {
                    vm.companyItems = res.data.rec;
                    res.data.rec.forEach(r => vm.companyList.push({ text: r.compnyname, value: r.id }));
                })
                .catch(err => { vm.errMsg = err; });
        },

        loadBranch() {
            const vm = this;
            this.$store.dispatch('get', { url: '/branch/all' })
                .then(res => {
                    vm.branchItems = res.data.rec;
                    res.data.rec.forEach(r => vm.branchList.push({ text: r.brchname, value: r.id }));
                })
                .catch(err => { vm.errMsg = err; });
        },

        loadDepartment() {
            const vm = this;
            this.$store.dispatch('get', { url: '/department/all' })
                .then(res => {
                    vm.departmentItems = res.data.rec;
                    res.data.rec.forEach(r => vm.departmentList.push({ text: r.deptname, value: r.id }));
                })
                .catch(err => { vm.errMsg = err; });
        },

        loadDivision() {
            const vm = this;
            this.$store.dispatch('get', { url: '/division/all' })
                .then(res => {
                    vm.divisionItems = res.data.rec;
                    res.data.rec.forEach(r => vm.divisionList.push({ text: r.divnname, value: r.id }));
                })
                .catch(err => { vm.errMsg = err; });
        },

        loadSection() {
            const vm = this;
            this.$store.dispatch('get', { url: '/section/all' })
                .then(res => {
                    vm.sectionItems = res.data.rec;
                    res.data.rec.forEach(r => vm.sectionList.push({ text: r.sectioname, value: r.id }));
                })
                .catch(err => { vm.errMsg = err; });
        },

        loadUnit() {
            const vm = this;
            this.$store.dispatch('get', { url: '/unit/all' })
                .then(res => {
                    vm.unitItems = res.data.rec;
                    res.data.rec.forEach(r => vm.unitList.push({ text: r.unitname, value: r.id }));
                })
                .catch(err => { vm.errMsg = err; });
        },

        loadEmpType() {
            const vm = this;
            this.$store.dispatch('get', { url: '/emptype/all' })
                .then(res => {
                    vm.emptypeItems = res.data.rec;
                    res.data.rec.forEach(r => vm.emptypeList.push({ text: r.emptypedesc, value: r.id }));
                })
                .catch(err => { vm.errMsg = err; });
        },

        loadGrade() {
            const vm = this;
            this.$store.dispatch('get', { url: '/grade/all' })
                .then(res => {
                    vm.gradeItems = res.data.rec;
                    res.data.rec.forEach(r => vm.gradeList.push({ text: r.grddesc, value: r.id }));
                })
                .catch(err => { vm.errMsg = err; });
        },

        loadJob() {
            const vm = this;
            this.$store.dispatch('get', { url: '/job/all' })
                .then(res => {
                    vm.jobItems = res.data.rec;
                    res.data.rec.forEach(r => vm.jobList.push({ text: r.jobtitle, value: r.id }));
                })
                .catch(err => { vm.errMsg = err; });
        },

        loadPosition() {
            const vm = this;
            this.$store.dispatch('get', { url: '/position/all/op' })
                .then(res => {
                    vm.positionItems = res.data.rec;
                    res.data.rec.forEach(r => vm.positionList.push({ text: r.posdesc, value: r.id }));
                })
                .catch(err => { vm.errMsg = err; });
        },

        resolveNames(items, ids, field, idField = 'id') {
            if (!ids || !ids.length) return '';
            return items.filter(i => ids.includes(i[idField])).map(i => i[field]).join(', ');
        },

        modifyItemHandler(item) {
            this.isExisting = true;
            this.itemHolder = item;
            this.selections = {
                ...item,
                workgroupids: this.toIdArray(item.workgroupids),
                compnyids:   this.toIdArray(item.compnyids),
                branchids:   this.toIdArray(item.branchids),
                deptids:     this.toIdArray(item.deptids),
                divisionids: this.toIdArray(item.divisionids),
                sectionids:  this.toIdArray(item.sectionids),
                unitids:     this.toIdArray(item.unitids),
                emptypeids:  this.toIdArray(item.emptypeids),
                gradeids:    this.toIdArray(item.gradeids),
                jobids:      this.toIdArray(item.jobids),
                positionids: this.toIdArray(item.positionids),
            };
            this.eligibledialog = true;
        },

        deleteItemHandler(item) {
            this.detailItem.splice(this.detailItem.indexOf(item), 1);
            this.$emit('input', this.detailItem);
        },

        saveEligibleGroupInput() {
            this.isErr = false;

            // Compute all display strings from IDs at save time
            const rowData = {
                ...this.selections,
                workgroupids: [...this.selections.workgroupids],
                compnyids:   [...this.selections.compnyids],
                branchids:   [...this.selections.branchids],
                deptids:     [...this.selections.deptids],
                divisionids: [...this.selections.divisionids],
                sectionids:  [...this.selections.sectionids],
                unitids:     [...this.selections.unitids],
                emptypeids:  [...this.selections.emptypeids],
                gradeids:    [...this.selections.gradeids],
                jobids:      [...this.selections.jobids],
                positionids: [...this.selections.positionids],
                workgroupcodes: this.resolveNames(this.workgroupItems, this.selections.workgroupids, 'valuecode', 'valvalueid'),
                workgroupdescs: this.resolveNames(this.workgroupItems, this.selections.workgroupids, 'valuedesc', 'valvalueid'),
                companycodes:  this.resolveNames(this.companyItems,    this.selections.compnyids,   'compnycode'),
                companynames:  this.resolveNames(this.companyItems,    this.selections.compnyids,   'compnyname'),
                branchcodes:   this.resolveNames(this.branchItems,     this.selections.branchids,   'brchcode'),
                branchnames:   this.resolveNames(this.branchItems,     this.selections.branchids,   'brchname'),
                deptcodes:     this.resolveNames(this.departmentItems, this.selections.deptids,     'deptcode'),
                deptnames:     this.resolveNames(this.departmentItems, this.selections.deptids,     'deptname'),
                divisioncodes: this.resolveNames(this.divisionItems,   this.selections.divisionids, 'divncode'),
                divisionnames: this.resolveNames(this.divisionItems,   this.selections.divisionids, 'divnname'),
                sectioncodes:  this.resolveNames(this.sectionItems,    this.selections.sectionids,  'sectiocode'),
                sectionnames:  this.resolveNames(this.sectionItems,    this.selections.sectionids,  'sectioname'),
                unitcodes:     this.resolveNames(this.unitItems,       this.selections.unitids,     'unitcode'),
                unitnames:     this.resolveNames(this.unitItems,       this.selections.unitids,     'unitname'),
                emptypecodes:  this.resolveNames(this.emptypeItems,    this.selections.emptypeids,  'emptype'),
                emptypedescs:  this.resolveNames(this.emptypeItems,    this.selections.emptypeids,  'emptypedesc'),
                gradecodes:    this.resolveNames(this.gradeItems,      this.selections.gradeids,    'grdcode'),
                gradedescs:    this.resolveNames(this.gradeItems,      this.selections.gradeids,    'grddesc'),
                jobcodes:      this.resolveNames(this.jobItems,        this.selections.jobids,      'jobcode'),
                jobtitles:     this.resolveNames(this.jobItems,        this.selections.jobids,      'jobtitle'),
                positioncodes: this.resolveNames(this.positionItems,   this.selections.positionids, 'poscode'),
                positiondescs: this.resolveNames(this.positionItems,   this.selections.positionids, 'posdesc'),
            };

            if (this.isExisting) {
                const index = this.detailItem.findIndex(item => item === this.itemHolder);
                if (index !== -1) {
                    this.$set(this.detailItem, index, { ...rowData, action: this.itemHolder.action });
                }
            } else {
                rowData.id = null;
                rowData.action = 1;
                this.detailItem.push(rowData);
            }

            this.$emit('input', this.detailItem);
            this.eligibledialog = false;
            this.resetSelections();
        },

        closeEligibleGroupInput() {
            this.eligibledialog = false;
            this.isErr = false;
            this.resetSelections();
        },

        resetSelections() {
            this.selections = this.emptySelections();
            this.isExisting = false;
            this.itemHolder = null;
        },
    },

    created() {
        this.loadWorkgroup();
        this.loadCompany();
        this.loadBranch();
        this.loadDepartment();
        this.loadDivision();
        this.loadSection();
        this.loadUnit();
        this.loadEmpType();
        this.loadGrade();
        this.loadJob();
        this.loadPosition();
    }
}
</script>
